const FontEscapeFilter = (input) => (input ? input.replaceAll('"', "'") : '');

export default FontEscapeFilter;
